import React from 'react';
import { canUseDOM } from 'exenv';
import { PropTypes } from 'prop-types';
import {
  FacebookShareButton,
  LinkedinShareButton,
  RedditShareButton,
  TwitterShareButton,
  TwitterIcon,
  FacebookIcon,
  LinkedinIcon,
  RedditIcon,
} from 'react-share';

const style = { outline: 'none', margin: '10px 0px', width: 32, height: 32 };

function ShareSheet({ title, description, url }) {
  const currentUrl =
    url || (canUseDOM ? window.location.href : 'https://www.pipesearch.com/');
  return (
    <div>
      <LinkedinShareButton
        title={title}
        summary={description}
        source="PipeSearch"
        style={style}
        url={currentUrl}
      >
        <LinkedinIcon size={32} round />
      </LinkedinShareButton>

      <FacebookShareButton style={style} url={currentUrl}>
        <FacebookIcon size={32} round />
      </FacebookShareButton>

      <TwitterShareButton
        title={title}
        via="PipeSearch"
        style={style}
        url={currentUrl}
      >
        <TwitterIcon size={32} round />
      </TwitterShareButton>

      <RedditShareButton
        title={title}
        summary={description}
        source="PipeSearch"
        style={style}
        url={currentUrl}
      >
        <RedditIcon size={32} round />
      </RedditShareButton>
    </div>
  );
}

ShareSheet.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  url: PropTypes.string,
};

export default ShareSheet;
